import { StackProps } from "react-bootstrap";
import { PackageDetailsTiming } from "../../../../api/models";
import { EPhaseNames } from "../../../../shared/enums/phases.enums";
import { TimingLabel } from "../../../../shared/enums/labels.enums";

export interface ITimingListProps extends StackProps {
  timing: PackageDetailsTiming;
  phase: EPhaseNames | undefined;
}

export interface ITimingListItem {
  label: TimingLabel;
  value?: string | null | undefined;
}

export const DefaultTimingListProps: ITimingListProps = {
  phase: undefined,
  timing: {},
};
